var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5021 0C5.16335 0 0 4.93305 0 10.9891C0 17.0673 5.16335 22 11.5021 22C17.8408 22 23.0271 17.0669 23.0271 10.9891C23.0271 4.93305 17.8408 0 11.5021 0ZM19.3622 16.1863C16.8497 16.4506 14.1297 16.5166 11.5021 16.5166C8.87441 16.5166 6.15445 16.4506 3.61876 16.1863C2.90424 16.1204 2.53536 15.944 2.44306 15.2172C2.30493 13.8297 2.30493 12.4203 2.30493 10.9891C2.30493 9.57966 2.30493 8.17026 2.44306 6.78275C2.53536 6.056 2.90391 5.87995 3.61876 5.81365C6.15412 5.54941 8.87409 5.48343 11.5017 5.48343C14.1294 5.48343 16.8494 5.54941 19.3618 5.81365C20.0996 5.87963 20.4681 6.056 20.5604 6.78244C20.6757 8.16994 20.6757 9.57934 20.6757 10.9887C20.6757 12.42 20.6757 13.8294 20.5604 15.2169C20.4681 15.9437 20.0996 16.1197 19.3618 16.1857L19.3622 16.1863Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8457 10.989C6.8457 8.56672 8.87406 6.54065 11.5017 6.54065C14.1294 6.54065 16.1577 8.56672 16.1577 10.989C16.1577 13.4335 14.1294 15.4595 11.5017 15.4595C8.87406 15.4595 6.8457 13.4335 6.8457 10.989V10.989Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.4ecd2aa3e3cb0c11bbe86b6af83cac80.svg";
export { ForwardRef as ReactComponent };